import {Injectable} from '@angular/core';
import {AbstractHttpService} from './abstract-http-service';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {catchError} from 'rxjs/operators';
import {MakeModel} from '../model/make.model';
import {VehicleModel} from '../model/vehicle-model.model';
import {AccountModelOption} from '../model/account-model-option.interface';

@Injectable({
  providedIn: 'root'
})
export class VehicleService extends AbstractHttpService {

  options = {
    headers: this.acceptJsonHeaders,
    withCredentials: true
  };

  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  /**
   * Get all active makes
   * @param active
   */
  getAllMakes(active: boolean = true): Observable<MakeModel[]> {
    return this.httpClient.get<MakeModel[]>(
      `//${environment.autoDomain}:${environment.autoPort}/api/makes?active=${active}&order[name]=asc`,
      this.options
    ).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Get all active models
   * @param active
   */
  getAllModels(active: boolean = true): Observable<VehicleModel[]> {
    const requestUrl = `//${environment.autoDomain}:${environment.autoPort}/api/models?active=${active}&order[name]=asc`;
    const response = this.httpClient.get<VehicleModel[]>(requestUrl, this.options).pipe(
      catchError(this.handleError)
    );
    return response;
  }

  /**
   * Loads active on-make model options for an account.
   */
  getAccountModelOptions(accountId: number): Observable<AccountModelOption[]> {
    const requestUrl = `//${environment.autoDomain}:${environment.autoPort}/api/accounts/${accountId}/model-options`;
    const response = this.httpClient.get<AccountModelOption[]>(requestUrl, this.options).pipe(
      catchError(this.handleError)
    );

    return response;
  }

}
